export default {
    methods: {
        linkForPage(page) {
            let urlSanitizedPageTitle = page.title.replace(/\s/g, '_').replace(/[^a-zA-Z0-9_-]/g, '')

            if (!urlSanitizedPageTitle) {
                urlSanitizedPageTitle = encodeURIComponent(page.title.replace(/\(/g, '').replace(/\)/g, ''))
            }

            if (!urlSanitizedPageTitle) {
                urlSanitizedPageTitle = 'page'
            }

            return `/wiki/pages/${page.shortid}/${urlSanitizedPageTitle}.html`
        }
    }
}
